export const opCodeSeparatorChipLimits = (state) => {
    // eslint-disable-next-line functional/no-expression-statements, functional/immutable-data
    state.lastCodeSeparator = state.ip;
    return state;
};
//# sourceMappingURL=bch-2025-code-separator.js.map